var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "app-navigation-caption-mod" }, [
    _c("div", { staticClass: "app-navigation-caption-div" }, [
      _c(
        "div",
        {
          staticClass: "app-navigation-caption-icon",
          class:
            ((_obj = {
              "icon-loading-small": _vm.loading,
            }),
            (_obj[_vm.icon] = _vm.icon && _vm.isIconShown),
            _obj),
        },
        [!_vm.loading ? _vm._t("icon") : _vm._e()],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "app-navigation-caption__title",
          attrs: { title: _vm.title },
        },
        [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    _vm.hasUtils
      ? _c(
          "div",
          { staticClass: "app-navigation-entry__utils" },
          [
            _c(
              "Actions",
              {
                attrs: {
                  "menu-align": "right",
                  placement: _vm.menuPlacement,
                  open: _vm.menuOpen,
                  "force-menu": _vm.forceMenu,
                  "default-icon": _vm.menuIcon,
                },
                on: { "update:open": _vm.onMenuToggle },
              },
              [_vm._t("actions")],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }